"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
type DepartmentStackContextProps = {
  pushParentDepartment: (departmentId: string) => void;
  popParentDepartment: () => void;
  resetParentDepartment: () => void;
  parentDepartmentId: string | null;
  selectedDepartmentName: string | null;
  setSelectedDepartmentName: (name: string | null) => void;
};
const DepartmentStackContext = React.createContext<DepartmentStackContextProps | null>(null);
export const useDepartmentStackContext = () => {
  const context = React.useContext(DepartmentStackContext);
  if (!context) {
    throw new Error("useDepartmentStackContext must be used within a DepartmentStackContext.Provider");
  }
  return context;
};
export const DepartmentStackProvider = t0 => {
  const $ = _c(13);
  const {
    children
  } = t0;
  const [selectedDepartmentName, setSelectedDepartmentName] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [departmentCodesStack, setDepartmentCodesStack] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = departmentCode => {
      setDepartmentCodesStack(prev => [...prev, departmentCode]);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const pushParentDepartment = t2;
  let popParentDepartment;
  let resetParentDepartment;
  if ($[2] !== departmentCodesStack.length) {
    popParentDepartment = () => {
      if (departmentCodesStack.length > 1) {
        setDepartmentCodesStack(_temp);
        return;
      }
      resetParentDepartment();
    };
    resetParentDepartment = () => {
      setDepartmentCodesStack(_temp2);
      setSelectedDepartmentName(null);
    };
    $[2] = departmentCodesStack.length;
    $[3] = popParentDepartment;
    $[4] = resetParentDepartment;
  } else {
    popParentDepartment = $[3];
    resetParentDepartment = $[4];
  }
  const parentDepartmentId = departmentCodesStack[departmentCodesStack.length - 1] ?? null;
  let t3;
  if ($[5] !== parentDepartmentId || $[6] !== popParentDepartment || $[7] !== resetParentDepartment || $[8] !== selectedDepartmentName) {
    t3 = {
      pushParentDepartment,
      popParentDepartment,
      resetParentDepartment,
      parentDepartmentId,
      selectedDepartmentName,
      setSelectedDepartmentName
    };
    $[5] = parentDepartmentId;
    $[6] = popParentDepartment;
    $[7] = resetParentDepartment;
    $[8] = selectedDepartmentName;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const contextValue = t3;
  let t4;
  if ($[10] !== children || $[11] !== contextValue) {
    t4 = <DepartmentStackContext.Provider value={contextValue}>{children}</DepartmentStackContext.Provider>;
    $[10] = children;
    $[11] = contextValue;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
function _temp(prev_0) {
  return prev_0.slice(0, -1);
}
function _temp2(prev_1) {
  return prev_1.slice(0, 0);
}